import type { CheckboxField } from '@aquilixshop/ui-react';
import { FieldRow } from '../FieldRow';

/**
 * Toggle switch (mockup style) — `role="switch" aria-checked`, NOT a raw checkbox (build-plan §6.3).
 * Commits immediately (discrete control).
 *
 * `disabled` is for the switches the STORE owns, not the seller — a choice that exists in the schema but
 * has exactly one valid answer for this store (see `SectionForm`'s cart lock). The switch still shows the
 * value that applies, greyed and unclickable, rather than disappearing: a hidden control reads as a missing
 * feature, a greyed one with its reason underneath reads as "not yours to set here".
 */
export function CheckboxControl({
  field,
  value,
  onChange,
  disabled = false,
}: {
  field: CheckboxField;
  value: boolean | undefined;
  onChange: (next: boolean) => void;
  disabled?: boolean;
}) {
  const checked = value ?? field.default ?? false;
  return (
    <FieldRow
      id={field.id}
      label={field.label}
      info={field.info}
      labelAs="span"
      layout="row"
      disabled={disabled}
    >
      <button
        type="button"
        id={field.id}
        className="bld-switch"
        role="switch"
        aria-checked={checked}
        aria-label={field.label}
        disabled={disabled}
        onClick={() => onChange(!checked)}
      >
        <span className="bld-switch__track" aria-hidden="true">
          <span className="bld-switch__knob" />
        </span>
      </button>
    </FieldRow>
  );
}
